import React from 'react';
import App from './app/components/App';
import { render } from 'react-dom';


require ('./app.scss');

//import Wheel from './app/Wheel';

// Assets
//import blankImg from './images/blank.png';

//const assetsLoader = new AssetsLoader();
//const wheel = new Wheel();

window.addEventListener('DOMContentLoaded', () => {
  let containerDiv = document.createElement('div');
  containerDiv.id = 'app';
  document.body.appendChild(containerDiv)
  render(<App/>, containerDiv);
});




// WEBPACK FOOTER //
// ./src/main.js